import {useEffect, useState} from 'react';
import "./css/ScrollTop.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
const ScrollTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if(window.scrollY > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };
        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
  return (
    <button
        onClick={scrollToTop}
        className={`scroll-to-top ${isVisible ? "show": ""}`}
    >
        <FontAwesomeIcon icon={ faArrowUp } />
    </button>
  );
};

export default ScrollTop;
